var map = {
	"./SubSections/delegations-main-section-view.js": 879,
	"./SubSections/governance-section-view.js": 613,
	"./SubSections/main-section-view.js": 483,
	"./ballot/create.js": 875,
	"./ballot/index.js": 614,
	"./ballot/view.js": 876,
	"./clean/index.js": 615,
	"./create/delegation.js": 616,
	"./create/index.js": 431,
	"./create/nav.js": 630,
	"./create/organization.js": 624,
	"./delegations/hostOptions.js": 359,
	"./delegations/index.js": 283,
	"./delegations/view.js": 627,
	"./index.js": 617,
	"./subDAOs/index.js": 432,
	"./subDAOs/view.js": 631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1606;